// @flow

/* eslint react/forbid-prop-types:0 */

import React, { Component } from 'react';
import BackgroundPinImages from 'app/common/react/components/growth/activation/BackgroundPinImages';
import BEST_GENDER_AGNOSTIC_PIN_IMAGES from 'app/common/react/components/growth/activation/NuxConst/bestGenderAgnosticPinImages';
import defaultCSS from 'app/common/react/components/growth/unauth/DefaultCSS';
import fullPageModalCSS from 'app/common/react/components/growth/unauth/FullPageModal/FullPageModalCSS';
import FullPageSignup from 'app/common/react/components/growth/unauth/signup/FullPageSignup/FullPageSignup';
import GoogleOneTapPresenter from 'app/common/react/components/growth/unauth/signup/GoogleOneTap/GoogleOneTapPresenter';
import i18n from 'app/common/lib/i18n';
import InlineStyle from 'app/common/react/components/InlineStyle';
import PageContext from 'app/common/react/components/growth/unauth/PageContext';
import resetCSS from 'app/common/react/components/growth/unauth/ResetCSS';
import signupCSS from 'app/common/react/components/growth/unauth/signup/SignupCSS';
import SignupWelcomeLoading from 'app/common/react/components/growth/unauth/signup/SignupWelcomeLoading/SignupWelcomeLoading';
import type { GenericAuthenticationCredsType } from 'app/packages/pinterest-authentication/registration';
import { compose } from 'redux';
import { FullPageSignupToggleType } from 'app/common/react/components/growth/unauth/signup/FullPageSignup/FullPageSignupToggleType';
import withUnauthSeoExperiments, {
  type UnauthSeoExperiments,
} from 'app/common/lib/react/withUnauthSeoExperiments';
import {
  SignupTypes,
  SignupSource,
} from 'app/common/react/components/growth/unauth/signup/constants';
import {
  withRequestContext,
  type RequestContextType,
} from 'app/common/react/components/RequestContext';
import { Box, Button } from 'gestalt';

const cssStyles = (isMobile) => resetCSS() + defaultCSS() + signupCSS(false) + fullPageModalCSS();

type OwnProps = {|
  options: {|
    board_invite: boolean,
    next: string,
    auto_follow: any,
    prev: string,
    amp_client_id: string,
  |},
  requestContext: RequestContextType,
|};

type Props = {|
  ...OwnProps,
  seoUnauthExperiments: UnauthSeoExperiments,
|};

type State = {|
  signupSource: string,
  type: $Values<typeof SignupTypes>,
  mfaCreds: ?GenericAuthenticationCredsType,
  socialRegistrationCredentials?: GenericAuthenticationCredsType,
  showingSignupWelcomeLoading?: boolean,
|};

class UnauthLoginPage extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      signupSource: this.props.options.board_invite ? SignupSource.boardInvite : SignupSource.login,
      type: SignupTypes.login,
      mfaCreds: null,
    };
  }

  CONTAINER_ID = 'login_page';
  showSocialConnectExtraInfoCollection = (type) => (
    network,
    userData,
    credentialsAndLoggingData,
  ) => {
    this.setState({
      type,
      socialRegistrationCredentials: {
        type: network,
        credentialsAndLoggingData,
        userData,
      },
    });
  };

  render() {
    const { seoUnauthExperiments, options, requestContext } = this.props;
    const { type } = this.state;

    const magicLinkGroup = seoUnauthExperiments.v2ActivateExperiment('magic_link_login') || '';
    requestContext.experiments.flush();

    return (
      <PageContext page="login">
        <div
          style={{
            position: 'absolute',
            top: '0px',
            width: '100%',
            height: '100%',
          }}
        >
          <div
            style={{
              overflowY: 'hidden',
              bottom: '0px',
              left: '0px',
              right: '0px',
              top: '0px',
              position: 'absolute',
            }}
          >
            <BackgroundPinImages
              disableFlexibleBGPins
              pinImages={BEST_GENDER_AGNOSTIC_PIN_IMAGES}
            />
          </div>
          <div
            style={{
              background: 'rgba(0,0,0,.5)',
              bottom: '0px',
              left: '0px',
              right: '0px',
              top: '0px',
              position: 'fixed',
            }}
          />
          {this.state.showingSignupWelcomeLoading ? (
            <SignupWelcomeLoading />
          ) : (
            <React.Fragment>
              <div
                style={{
                  left: '50%',
                  top: '50%',
                  position: 'absolute',
                  transform: 'translate(-50%, -50%)',
                }}
              >
                <InlineStyle unsafeCSS={cssStyles(false)} />
                <FullPageSignup
                  AMPClientId={options.amp_client_id}
                  container={this.CONTAINER_ID}
                  handleShowingSignupWelcomeLoading={(shouldShow) =>
                    this.setState({
                      showingSignupWelcomeLoading: shouldShow,
                    })
                  }
                  magicLinkGroup={magicLinkGroup}
                  mfaCreds={this.state.mfaCreds}
                  nextUrlParam={options.next || '/'}
                  removePinterestNumbers
                  signupSource={this.state.signupSource}
                  toggleType={FullPageSignupToggleType.SMALL_TOGGLE}
                  socialRegistrationCredentials={this.state.socialRegistrationCredentials}
                  type={this.state.type}
                  languageLocation="loginPage"
                />
              </div>
              <Box
                alignItems="stretch"
                height={9}
                left
                top
                marginLeft={6}
                marginTop={12}
                width={130}
                position="absolute"
              >
                <Button
                  onClick={() =>
                    this.setState(({ type }) => {
                      if (type === 'login') {
                        return { type: 'signup' };
                      }
                      return { type: 'login' };
                    })
                  }
                  text={
                    type === 'login'
                      ? i18n._('Sign up', 'sign up for account toggle on homepage')
                      : i18n._('Log in')
                  }
                />
              </Box>
              <GoogleOneTapPresenter
                container={this.CONTAINER_ID}
                handleLoginError={() => {}}
                handleLoginWithMfa={(creds) => {
                  this.setState({
                    type: SignupTypes.loginMfa,
                    mfaCreds: creds,
                  });
                }}
                handleSignupConfirmed={this.showSocialConnectExtraInfoCollection(
                  SignupTypes.socialSignupWithAge,
                )}
                handleSignupError={() => {
                  this.setState({
                    type: SignupTypes.signup,
                  });
                }}
                handleShowLogin={() => {}}
                nextUrl={options.next}
              />
            </React.Fragment>
          )}
        </div>
      </PageContext>
    );
  }
}

export default compose(
  withRequestContext,
  withUnauthSeoExperiments,
)(UnauthLoginPage);
